/**
 * Saved templates (Mischweg spec 2026-09-23 §15) as snippets_v2 rows.
 * Origin "webmag" = global row (group_id NULL, sysadmins only), "kunde" =
 * the group's row for all its projects, "projekt" = the group's row marked
 * with the project it belongs to (the catalog lists it only there). A
 * Bereich keeps one doc in data.section (data.bereich before the English rename), a module or page several in
 * data.bereiche. data.html is the rendered reader markup the catalog tile
 * draws live.
 */
import { generateWmId } from '@/editor-v2/utils/wmId';

export function herkunftOptionen({ isSysAdmin, projectId }) {
  return [
    ...(projectId != null ? ['projekt'] : []),
    'kunde',
    ...(isSysAdmin ? ['webmag'] : []),
  ];
}

export function buildVorlageRow(paket, form, { groupId, projectId }) {
  const rollen = [];
  paket.bereiche.forEach((doc) => {
    if (doc.section.role && rollen.indexOf(doc.section.role) < 0) rollen.push(doc.section.role);
  });
  return {
    group_id: form.herkunft === 'webmag' ? null : groupId,
    name: `vorlage-${generateWmId()}`,
    data: {
      ...(paket.groesse === 'bereich' ? { section: paket.bereiche[0] } : { bereiche: paket.bereiche }),
      vorlage: {
        groesse: paket.groesse,
        herkunft: form.herkunft,
        beschreibung: form.beschreibung,
        beispiel: form.beispiel === true,
        ...(form.herkunft === 'projekt' ? { projektId: projectId } : {}),
      },
      rollen,
      html: paket.html,
      preview: '',
      title_de: form.name,
      title_en: form.name,
      categories: ['Templates'],
      type: 'vorlage',
      active: true,
      version: '2',
    },
  };
}
